import { useState } from "react";
import SelfserviceLayout from "../../../components/layouts/SelfserviceLayout";
import { Helmet } from "react-helmet-async";
import useUserStore from "../../../state-management/useUserStore";
import { useGetMyAnnouncement } from "../../../services/announcement.service";
import { AnnouncementOrderBy } from "../../../models/announcement.dto";
import { formatDate } from "../../../helpers/appHelpers";
import { SkewLoader } from "react-spinners";
import AnnouncementsView from "./resources/AnnouncementsView";
import { BsArrowRightShort } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../../routes/routes.paths";

const SelfserviceAnnouncement = () => {
    const navigate = useNavigate();
    const currentUser = useUserStore().currentUser.user;
    const companyProfiles = (currentUser.companyProfiles || [])[0];
    const [openAnnouncementsView, setOpenAnnouncementsView] = useState(false);
    const [selectedAnnouncementId, setSelectedAnnouncementId] = useState(0);


    const {
        data: defaultAnnouncements,
        isLoading: loadingDefaultAnnouncements,
    } = useGetMyAnnouncement({
        page: 1,
        limit: 5,
        orderBy: AnnouncementOrderBy.PUBLISH_DATE_DESC,
    });

    return (
        <SelfserviceLayout pageHeader="Announcements">
            <div className="mt-9 lg:mt-[38px] pb-10 lg:pb-20">
                <div className="flex justify-between max-lg:items-center text-charcoal mb-6 lg:mb-5">
                    {/* <h2 className="font-bold text-2sm lg:text-[19px]">
                        Announcements
                    </h2> */}
                    <div
                        className="border-b border-transparent flex items-center font-semibold text-2xs lg:text-2sm hover:cursor-pointer hover:border-black"
                        onClick={() => {
                            setSelectedAnnouncementId(0);
                            setOpenAnnouncementsView(true);
                        }}
                    >
                        <span>View more</span>
                        <BsArrowRightShort className="text-xl lg:text-2xl" />
                    </div>
                </div>
                <div className="space-y-3 border border-[#333333] border-opacity-[15%] rounded-lg lg:px-5 px-3 py-2">
                    {(loadingDefaultAnnouncements && !defaultAnnouncements?.data?.length) && (
                        <div className="text-center py-[80px]">
                            <SkewLoader color="#F58B00" />
                        </div>
                    )}
                    {(!loadingDefaultAnnouncements && !defaultAnnouncements?.data?.length) && (
                        <div className="text-center py-[80px] max-lg:text-sm">
                            No announcements to show.
                        </div>
                    )}
                    {defaultAnnouncements?.data?.map((announcement, index) => (
                        <div 
                            key={announcement.id} 
                            className={`py-4 lg:py-6 flex justify-between items-start border-gray-200 cursor-pointer 
                                ${index === 0  ? "" : "border-t"} hover:scale-y-[1.05] transition-all`
                            }
                            onClick={() => {
                                setSelectedAnnouncementId(announcement.id);
                                setOpenAnnouncementsView(true);
                            }}
                        >
                            <div className="flex gap-3">
                                <div className="min-h-[4px] max-h-[4px] min-w-[4px] rounded-full bg-secondary-red mt-2" />
                                <div className="lg:text-2sm text-2xs">
                                    <h3>{announcement.title}</h3>
                                    <p className="text-gray-500 mt-4 line-clamp-1">{announcement.body}</p>
                                </div>
                            </div>
                            <p className="lg:text-xs text-[10px] w-[20%] lg:w-[15%] flex justify-end text-gray-500">
                                {formatDate(announcement.publishDate)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
            <AnnouncementsView
                open={openAnnouncementsView} 
                setOpen={setOpenAnnouncementsView}
                selectedAnnouncementId={selectedAnnouncementId} 
            />
        </SelfserviceLayout>
    );
};

export default SelfserviceAnnouncement;
